export default "__VITE_ASSET__q74$YWFo__"